function pxToRem(value) {
    return `${value / 16}rem`;
}

function responsiveFontSizes({ sm, md, lg }) {
    return {
        '@media (max-width:600px)': {
            fontSize: pxToRem(sm)
        },
        '@media (min-width:900px)': {
            fontSize: pxToRem(md)
        },
        '@media (min-width:1200px)': {
            fontSize: pxToRem(lg)
        }
    };
}

const FONT_PRIMARY = 'Public Sans, sans-serif';

const typography = {
    fontFamily: FONT_PRIMARY,
    fontWeightRegular: 400,
    fontWeightMedium: 600,
    fontWeightBold: 700,
    h1: {
        fontWeight: 400,
        lineHeight: 80 / 64,
        fontSize: pxToRem(50),
        letterSpacing: 4,
        ...responsiveFontSizes({ xs: 36, md: 50, lg: 50 })
    },
    h2: {
        fontWeight: 400,
        lineHeight: 64 / 48,
        fontSize: pxToRem(36),
        letterSpacing: 4,
        ...responsiveFontSizes({ xs: 28, md: 36, lg: 36 })
    },
    h3: {
        fontWeight: 400,
        lineHeight: 1.5,
        fontSize: pxToRem(25),
        letterSpacing: 0,
        ...responsiveFontSizes({ sm: 21, md: 25, lg: 25 })
    },
    h4: {
        fontWeight: 400,
        lineHeight: 1.5,
        fontSize: pxToRem(21),
        letterSpacing: 0.15,
        ...responsiveFontSizes({ sm: 18, md: 21, lg: 21 })
    },
    h5: {
        fontWeight: 500,
        lineHeight: 1.5,
        fontSize: pxToRem(18),
        ...responsiveFontSizes({ sm: 19, md: 20, lg: 20 })
    },
    h6: {
        fontWeight: 500,
        lineHeight: 28 / 18,
        fontSize: pxToRem(17),
        ...responsiveFontSizes({ sm: 18, md: 18, lg: 18 })
    },
    subtitle1: {
        fontWeight: 500,
        lineHeight: 1.5,
        fontSize: pxToRem(16)
    },
    subtitle2: {
        fontWeight: 500,
        lineHeight: 22 / 14,
        fontSize: pxToRem(14)
    },
    body1: {
        fontWeight: 400,
        lineHeight: 1.5,
        letterSpacing: 0.5,
        fontSize: pxToRem(17),
        ...responsiveFontSizes({ sm: 14, md: 17, lg: 17 })
    },
    body2: {
        lineHeight: 22 / 14,
        fontSize: pxToRem(14)
    },
    caption: {
        fontWeight: 400,
        lineHeight: '15.6px',
        letterSpacing: '0.4px',
        fontSize: pxToRem(13)
    },
    overline: {
        fontWeight: 500,
        lineHeight: 1.5,
        fontSize: pxToRem(12),
        letterSpacing: 1.1,
        textTransform: 'uppercase'
    },
    button: {
        fontWeight: 500,
        lineHeight: 24 / 14,
        fontSize: pxToRem(15),
        letterSpacing: 1.25,
        textTransform: 'capitalize'
    }
};

export default typography;
